import * as React from "react";
import {DialogActions, Grid, Typography, useTheme} from "@mui/material";
import {Item} from "../../../domains/common/components/Item";
import Box from "@mui/material/Box";
import {getDealStatusChips} from "../../../domains/common/components/Chips";
import {IndentSpace} from "../../../domains/common/components/Typography";
import RREventsContainer from "./RREvents";
import {useNotify} from "../../../domains/common/components/AlertNotify";
import {exceptionsTitle} from "../../../dictionaries";
import {useEffect, useState} from "react";
import {DealActionsEnums} from "../../../actions";
import {userOptions} from "../../../user";
import {stateManager} from "../../../stateManager";
import {ButtonBase} from "../../../domains/common/components/Button";
import {dealData, sendToRR} from "../deal";
import {getCurrentStatus, hasStatus, reloadStatus} from "../status";
import {getBackendURL} from "../../../fn";
import { DialogWindow } from "../../../domains/common/components/Dialog";

export default function DealMenu({dealId}) {
  const {openNotify} = useNotify();
  const [state, setState] = useState(0);

  let signButton;
  let paymentButton;
  let sendToRR;
  let rrEventsContainer;
  let archiveStatement;

  useEffect(() => {
    const unsubscribe = stateManager.subscribe(async (newState) => {
      if(newState.lastAction === DealActionsEnums.XML_STATEMENT_CREATE) {
        await reloadStatus(dealId);
        setState(state => setState(state++));
      }
    });

    return unsubscribe;
  }, [])

  if (
    hasStatus('XMLReady')
  ) {
    signButton = <SignButton dealId={dealId} />;
  }

  if (!hasStatus('dealSentToRR')) {
    sendToRR = <SendToRR openNotify={openNotify} dealId={dealId} />
  }

  if (getCurrentStatus() === 'rosreestrValidationError') {
    sendToRR = <SendToRR openNotify={openNotify} dealId={dealId} />
  }

  if (hasStatus('dealSentToRR') && getCurrentStatus() !== 'rosreestrValidationError') {
    archiveStatement = <ArchiveStatementDownloadBtn dealId={dealId} />
  }

  if (hasStatus('dealSentToRR')) {
    rrEventsContainer = <RREventsContainer dealId={dealId} />
  }

  if(hasStatus('rosreestrQuitance')) {
    paymentButton = <PaymentButton dealId={dealId} />
  }

  const theme = useTheme();

  return (
    <div>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Item sx={{backgroundColor: theme.palette.background.default}}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <Typography variant="subtitle1" gutterBottom>
                {getDealStatusChips(getCurrentStatus())}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Box display="flex" justifyContent="flex-end">
                {archiveStatement}
                <IndentSpace size={8}/>
                {paymentButton}
                <IndentSpace size={8}/>
                {rrEventsContainer}
                <IndentSpace size={8}/>
                {signButton}
                <IndentSpace size={8}/>
                {sendToRR}
              </Box>
            </Grid>
          </Grid>
        </Item>
      </Grid>
    </Grid>
    </div>
  )
}

export function SignButton({dealId}) {
  const ref = `/sign?dealId=${dealId}`
  return (
    <a href={ref}
       target={userOptions.openLinkCurrentTab ? "" : "_blank"}
    >
      <ButtonBase variant="contained" size="small">Перейти к подписанию</ButtonBase>
    </a>
  )
}

export function PaymentButton({dealId}) {
  const ref = `/payments?dealId=${dealId}`
  return (
    <a href={ref}
       target={userOptions.openLinkCurrentTab ? "" : "_blank"}
    >
      <ButtonBase variant="contained" size="small" color="success">Платежи</ButtonBase>
    </a>
  )
}

export function SendToRR({dealId, openNotify}) {
  const [sending, setSending] = useState(false);
  const [blockedForRegistration, setBlockedForRegistration] = useState(true);
  const [openDialog,setOpenDialog] = useState(false)

  const handleOpenDialog = () => {
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  if(
    !hasStatus('documentsSign')
  ) {
    return;
  }

  useEffect(() => {
    setBlockedForRegistration(dealData.deal.isBlockedForRegistration)

    const unsubscribe = stateManager.subscribe((newState) => {
      setBlockedForRegistration(newState.isBlockedForRegistration);
    });

    return unsubscribe;
  }, [])

  const sendToRosreestr = async () => {
    setSending(true)
    const result = await sendToRR(dealId);

    if(result.ok)
      openNotify({msg: "Отправлено", duration: 1000, type: 'success'})
    else
      openNotify({msg: exceptionsTitle[result.message] || result.message, duration: 3000, type: 'error'})

    setSending(false)
    handleCloseDialog()
  }

  const actionBtns = (
  <>
  <DialogActions sx={{display:"flex",justifyContent:'space-between',paddingX:3,paddingBottom:2}}>
    <ButtonBase color="primary" variant="contained" onClick={sendToRosreestr} autoFocus>Отправить</ButtonBase>
    <ButtonBase color="info" variant="contained" onClick={handleCloseDialog}>Отмена</ButtonBase>
  </DialogActions>
  </>)

  const button = (<>
    <ButtonBase variant="contained" size="small" color="success" disabled={blockedForRegistration} onClick={handleOpenDialog}>Отправить в Росреестр</ButtonBase>
      <DialogWindow
        isOpen={openDialog}
        onClose={handleCloseDialog}
        dialogTitle={'Отправка на регистрацию'}
        dialogText={'Внимание! После этого действия документы будут отправлены на регистрацию в Росреестр. Не совершайте отправку в целях тестирования'}
        actions={actionBtns}
          />
    </>
  )

  const loadingButton = (<ButtonBase variant="contained" size="small" color="success" disabled>Идёт отправка</ButtonBase>)

  return (
    sending ? loadingButton : button
  )
}

export function ArchiveStatementDownloadBtn({dealId}) {
  const onDownload = () => {
    const link = document.createElement("a");
    link.href = `${getBackendURL()}/deal/${dealId}/download`;
    link.click();
  };

  return (<ButtonBase variant="contained" size="small" onClick={onDownload}>Скачать результат</ButtonBase>);
}